import {
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "./opretFirmaInterface";

export const opretFirmaStep1InitialState: OpretFirmaStep1Formik = {
  advokatVirksomhed: true,
  land: "DK",
  inCVR: "yes-searchable",
  navn: "",
  produktionsenhed: undefined,
  adresseDar: undefined,
  andenAdresse: {
    adresselinie1: "",
    adresselinie2: "",
    adresselinie4: "",
    bynavn: "",
    postnummer: "",
    landekode: "",
    coNavn: "",
  },
  virksomhedsform: undefined,
  periodeFraDato: undefined,
};

export const opretFirmaStep2InitialState: OpretFirmaStep2Formik = {
  email: "",
  emailNotification: "",
  phone: "",
  website: "",
  ean: "",
  emailFaktura: "",
  fakturaAfsend: undefined,
  selskabstype: "",
};
